export const lightTheme = {
  colorPrimaryBg: "#f4f7fe",
  colorTextBase: "#1b254b",
  colorBorder: "#f4f7fe",
  colorBgContainer: "#ffffff",
  menuBgColor: "#f4f7fe",
};

export const darkTheme = {
  colorPrimaryBg: "#0a1436",
  colorTextBase: "#ffffff",
  colorBorder: "#0a1436",
  colorBgContainer: "#111c44",
  menuBgColor: "#1f294f",
};
